module.exports = __webpack_public_path__ + "img/xls.27d3328e.png";